import { render, staticRenderFns } from "./tax_expert_search.vue?vue&type=template&id=57ed07e2&scoped=true&"
import script from "./tax_expert_search.vue?vue&type=script&lang=js&"
export * from "./tax_expert_search.vue?vue&type=script&lang=js&"
import style0 from "./tax_expert_search.vue?vue&type=style&index=0&id=57ed07e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ed07e2",
  null
  
)

export default component.exports